import React from 'react';
import PropTypes, { any } from 'prop-types';

import Popup from '../../Popup';
import AvatarV2 from '../../cards/PlayerCard/ListViewComponents/AvatarV2';

import styles from '../EventDrawCreateEditPopup/eventDrawCreateEditPopup.scss';

const EventDeskFailedMembersPopup = (props) => {
    const {
        onCloseClick,
        failedMemberIds,
        playersDictByMemberId,
    } = props;

    const isIphone = /iPhone/i.test(navigator.userAgent);

    const failedPlayers = failedMemberIds.map(memberId => playersDictByMemberId[memberId] || {});

    return (
        <Popup
            className="popup-sm"
            popUpClassName={styles.eventDrawCreateEditPopup}
            onCloseClick={onCloseClick}
            config={{
                fullScreen: false,
                noPadding: true,
                scrollable: false,
                showCloseIcon: true,
                title: 'Adding players',
                isSideBar: true,
            }}
        >
            <div className={styles.content}>
                <div className={styles.section}>
                    <h6 className={`${styles.title} text-danger`}>
                        Attention
                    </h6>
                    <p>
                        The following players cannot be added into a draw because their registration division settings do not match.
                    </p>
                    {failedPlayers.map(player => (
                        <div className={styles.playerCard} key={player.id}>
                            <div className="d-flex aic pr8">
                                <div className="no-gutters">
                                    <div className="d-flex aic">
                                        <div className={`d-flex aic oh pr8`}>
                                            <AvatarV2 player={player} />
                                        </div>
                                        <div className="d-flex flex-col">
                                            {player.firstName} {player.lastName}
                                            <div className={`${styles.playerLocation} d-flex`}>
                                                <span>{player.gender}</span>
                                                {player.location?.display && (<span>&nbsp;•&nbsp;{player.location?.display}</span>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    <p>
                        Ensure that all settings match the following criteria:
                    </p>
                    <ul className="fs-14">
                        <li>Division registration</li>
                        <li>Gender</li>
                        <li>Game type</li>
                    </ul>
                    <p>
                        If you would like to add additional players to a draw, you can do so from the Player list.
                    </p>
                    <p>
                        Please click &quot;Continue&quot; to view your draw.
                    </p>
                </div>
            </div>

            <div className={styles.footer} style={isIphone ? null : { position: 'fixed', width: '400px', bottom: '0px', right: '0px', backgroundColor: '#fffff', paddingLeft: '20px', paddingRight: '20px', zIndex: 999 }}>
                <button
                    onClick={onCloseClick}
                    type="button"
                    className="btn btn-default text-uppercase flex-1"
                >
                    Continue
                </button>
            </div>
        </Popup>
    );
};

EventDeskFailedMembersPopup.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    failedMemberIds: PropTypes.arrayOf(any),
    playersDictByMemberId: PropTypes.objectOf(any),
};

EventDeskFailedMembersPopup.defaultProps = {
    failedMemberIds: [],
    playersDictByMemberId: {},
};

export default EventDeskFailedMembersPopup;
